var _defs, _g, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteriorPilotPhysicist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Physicist",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3600 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #898881;\n        opacity: .3;\n      }\n\n      .cls-2 {\n        fill: #e5e5e5;\n      }\n\n      .cls-3 {\n        fill: #b7b7b7;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #ff4800;\n      }\n\n      .cls-6 {\n        fill: #333;\n        opacity: .8;\n      }\n\n      .cls-7 {\n        fill: #f7edef;\n      }\n\n      .cls-8 {\n        fill: #0f0f0f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "620.91 1596.06 437.72 1596.06 319.1 1657.38 300.94 1826.81 757.7 1826.81 739.53 1657.38 620.91 1596.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "574.95 1841.1 481.26 1841.1 450.63 1594.26 605.58 1596.06 574.95 1841.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "466.85 1709.57 389.37 1725.79 401.98 1608.68 448.83 1590.66 466.85 1709.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "588.93 1709.6 666.41 1725.81 653.79 1608.7 606.95 1590.68 588.93 1709.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "571.55 1864.22 605.78 1828.18 633.97 1747.44 589.57 1709.27 571.55 1864.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "554.8 1877.13 505.01 1877.13 513.18 1680.75 546.64 1680.75 554.8 1877.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "555.13 1694.83 529.91 1702.37 504.68 1694.83 456.04 1622.19 317.3 1540.21 439.2 1468.14 604.02 1468.14 742.51 1540.21 603.78 1622.19 555.13 1694.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "705.92 1274.22 696.91 1258 571.25 1336.01 490.23 1336.01 364.15 1258.48 355.14 1274.69 368.38 1400.92 318.2 1536.12 438.59 1608.32 487.06 1613.02 509.39 1645.52 552.09 1645.52 574.07 1613.02 621.4 1608.32 743.28 1536.12 693.86 1400.82 705.92 1274.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "484.23 1864.19 450 1828.16 421.8 1747.41 466.21 1709.24 484.23 1864.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 340.72,
    y: 1736.6,
    width: 73.87,
    height: 5.41
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "332 1488 325 1510 351 1510 361 1529 382 1529 372 1488 332 1488"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "730 1488 737 1510 711 1510 701 1529 680 1529 690 1488 730 1488"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "820.97 2127 237.03 2127 205 1723.7 311.75 1570.95 746.25 1570.95 853 1723.7 820.97 2127"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "725.15 2098.1 332.85 2098.1 302.85 1723.03 340.36 1673.03 714.5 1673.03 755.15 1723.03 725.15 2098.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteriorPilotPhysicist);
export default __webpack_public_path__ + "static/media/interior-pilot-physicist.51209678c7cb7632b58ec21ea40316cf.svg";
export { ForwardRef as ReactComponent };